<template>
  <div>
    <p class="font-md">This lists completed landowner reports.</p>
    <PaginatedTable
      :fields="fields" ref='pTable'
      :busy="isBusy"
      noResultsText="You have no Complete Landowner Reports."
      tableId="completeLandownerReportsTable"
      :countLabel="cLabel"
      url="/landownerreport/myCompleteLandownerReports"
      perPageLabel="Reports"
    >
      <template v-slot:head()="data">
        {{data.label}}
      </template>
      <template  #table-busy>
        <LoadingSpinner  :message="`Loading Landowner Reports`" />
      </template>
      <template v-slot:cell(TownName)="data">
        <div class="mobile-row-center">
          {{data.item.TownName}}
        </div>
      </template>
      <template v-slot:cell(FONNumber)="data">
        <div class="mobile-row-center">
          {{data.item.FONNumber}}
        </div>
      </template>
      <template v-slot:cell(activeDate)="data">
        <div class="mobile-row-center">
          {{data.item.activeDate | dateString}}
        </div>
      </template>
      <template v-slot:cell(operationDate)="data">
        <div class="mobile-row-center">
          {{data.item.operationStartDate | dateString}}
          -
          {{data.item.operationEndDate | dateString}}
        </div>
      </template>
      <template v-slot:cell(lorStatus)="data">
        <div class="mobile-row-center">
          {{data.item.lorStatus}}
        </div>
      </template>
      <template v-slot:cell(reportYr)="data">
        <div class="mobile-row-center">
          {{data.item.reportingYear}}
        </div>
      </template>
      <template v-slot:cell(view)="data">
        <div class="text-right mobile-row-center">
          <router-link tag="a" size="sm" :to="`/landownerReport/${data.item.reportId}`">
            View
          </router-link>
        </div>
      </template>
    </PaginatedTable>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import PaginatedTable from '@/components/common/PaginatedTable.vue';
import LoadingSpinner from '@/components/common/LoadingSpinner.vue';

export default {
  name: 'MyCompleteLandownerReports',
  components: {
    PaginatedTable,
    LoadingSpinner,
  },
  data() {
    return {
      isBusy: false,
      cLabel: 'Landowner Reports',
      fields: [
        { key: 'townName', label: 'Town' },
        { key: 'nearestRoad', label: 'Nearest Road' },
        { key: 'fonNumber', label: 'FON Number' },
        { key: 'operationDate', label: 'Operation Start/End Date' },
        { key: 'lorStatus', label: 'LOR Status' },
        { key: 'reportYr', label: 'Report Year' },
        { key: 'view', label: '', stickyColumn: true },
      ],
    };
  },
  computed: {
    ...mapState(['isExtraSmall']),
  },
  watch: {
    isExtraSmall() {
      if (this.isExtraSmall) {
        // move actionField in front of basic fields
        this.shiftMobile();
      } else {
        this.cLabel = 'Landowner Reports';
        // move actionField to end of basic fields
        const actionField = this.fields.shift();
        this.fields.push(actionField);
      }
    },
  },
  methods: {
    shiftMobile() {
      const actionField = this.fields.pop();
      this.fields.unshift(actionField);
      this.cLabel = 'Reports';
    },
    activitiesString(value, key, item) {
      const activities = [];
      if (item.hasHarvest) activities.push('Harvest');
      if (item.hasRoadConstruction) activities.push('Road Construction');
      if (item.hasWaterCrossing) activities.push('Water Crossing');

      return activities.join(', ');
    },
  },
  created() {
    if (this.isExtraSmall) {
      // move actionField in front of basic fields
      this.shiftMobile();
    }
  },
};
</script>
